class NavbarController{
  /**
   *
   * @param $auth
   * @param $uibModal
   * @param $rootScope
   */
  constructor(
    $auth,
    $uibModal,
    $rootScope,
    $bookings,
    $state
  ){

    'ngInject';

    this.$auth            = $auth;
    this.$uibModal        = $uibModal;
    this.$rootScope       = $rootScope;
    this.$bookings        = $bookings;
    this.$state           = $state;
    this.watchStateChanges();
  }

  init(){
    this.isAuthenticated  = this.$auth.isAuthenticated();
    this.user             = null;
    this.showLogo         = false;
    if (this.isAuthenticated) {

      this.$auth.getUser$(true).then(user => {
        this.user = this.$auth.user;
      })

        this.$auth.company$.then(
            () => {
              this.$auth.invoiceAccounts$.then(
                  () => {

                      if (!this.$auth.company.invoice_account ||
                          this.$auth.company.invoice_account === this.$auth.defaultInvoiceAccount.uri) {
                          this.showLogo = true;
                      }
                  }
              )
            }
        );

      console.log('MODE', this.$auth.mode);
    }
  }

  watchStateChanges(){
   this.$rootScope.$on('$stateChangeSuccess', () => {
      $('#navbar-navigation').not('.collapsed').click();
      this.init();
    });
  }

  logout(){
    this.$auth.logout().then( () => this.$state.go('signin') );
  }

  openBookingCreate(){
    this.app.openedComponent = this.app.openedComponent ? null : 'booking-create-opened';
  }

  openAppSettings(){
    this.$uibModal.open({
      component: 'settings'
    });
  }

  get mode() {
    return this.$bookings.mode;
  }

  setMode(mode) {
    console.log(mode);
    this.$bookings.setMode(mode);
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    });
  }

  get isSpeditor() {
    return this.$auth.userHasRole('spedytor');
  }

}

export default NavbarController;



/** WEBPACK FOOTER **
 ** ./frontend/components/navbar/navbar.controller.js
 **/